import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { getFiscalYearFromDate, NonTimezoneSensitiveDate } from '@commenda/utils';

export const FiscalYearDropdown = ({
  value,
  allowPastYears = false,
  disabled,
  onChange,
  fiscalYearEndDate,
  fiscalYearEndDateMonth,
  incorporationDate,
}: {
  value: number | null;
  disabled?: boolean;
  allowPastYears?: boolean;
  onChange: (value: number | null) => void;
  fiscalYearEndDate: number;
  fiscalYearEndDateMonth: number;
  incorporationDate: string;
}) => {
  const shouldGenerateFiscalYearInRanges =
    fiscalYearEndDate !== 31 || fiscalYearEndDateMonth !== 12;

  // Lower bound is the fiscal year the incorporation date falls in, not its calendar year.
  // Fall back to the calendar year when the fiscal-year-end isn't known.
  const incorporationFiscalYear =
    fiscalYearEndDate && fiscalYearEndDateMonth
      ? getFiscalYearFromDate(
          incorporationDate,
          fiscalYearEndDateMonth,
          fiscalYearEndDate
        )
      : NonTimezoneSensitiveDate.fromISO8601String(incorporationDate).getYear();

  const startYear = allowPastYears
    ? new Date(0).getFullYear()
    : incorporationFiscalYear;

  const years = Array.from(
    { length: new Date().getFullYear() - startYear + 1 },
    (_, i) => startYear + i
  );

  const fiscalYearRanges = years.map((year) => {
    if (shouldGenerateFiscalYearInRanges) {
      return {
        year,
        display: `FY ${year}-${year + 1}`,
      };
    }
    return {
      year,
      display: `FY ${year}`,
    };
  });

  return (
    <Select
      value={value?.toString()}
      onValueChange={(newValue) => onChange(+newValue)}
      disabled={disabled}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select fiscal year" />
      </SelectTrigger>
      <SelectContent>
        {fiscalYearRanges.map((fiscalYearRange) => (
          <SelectItem
            value={fiscalYearRange.year.toString()}
            key={fiscalYearRange.year.toString()}
          >
            {fiscalYearRange.display}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
